import templateUrl from './validationItemCount.html'

/**
 * Counter for validation item.
 *
 * @example
 *   <tmr-validation-item-count antenna="$ctrl.antenna", items-count="$ctrl.itemCount"></tmr-validation-item-count>
 *
 * @type {ngComponent}
 * @prop {Antenna} antenna
 * @prop {itemsCount} items an array of counters generated by {@link TmrMovementHelper.countItems}
 */
export const tmrValidationItemCount = {
  ngType: 'component',
  templateUrl,
  bindings: {
    antenna: '<',
    itemsCount: '<',
  },
}
